import { dateTransform } from "helpers/dataHelpers";

export const columns = [
  {
    title: "Tier name",
    dataIndex: "tierName",
    key: "tierName",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
  },
  {
    title: "Points",
    dataIndex: "pointsAtMoment",
    key: "pointsAtMoment",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    width: 210,
    render: (date: string) =>
      dateTransform({
        date,
      }),
  },
];
